import * as React from "react";
import { InputWithAlert } from "../ui/input-with-alert";
import { formatDateString } from "@/styles";
import { format } from "date-fns";
import { VISA_OPTIONS } from "@/constants";
import { useTranslation } from "react-i18next";

export const DocumentVisa = (props) => {
  const { document } = props;
  const { entityType, createdAt, status, validFrom, validTo, uniqueId } = document;
  const { visaType } = document.metadata;
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <div className="pt-6">
        <InputWithAlert
          label={t('document_type')}
          disabled={true}
          type="text"
          value={entityType}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          className={"my-2 h-10 mb-5"}
          label={t('visa_type')}
          placeholder={t('visa_type')}
          readonly={true}
          value={VISA_OPTIONS.filter(e => e.value === visaType.value)[0].label ?? t('not_specified')}
          options={VISA_OPTIONS}
          disabled
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('created_at')}
          disabled={true}
          type="text"
          value={formatDateString(createdAt)}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('status')}
          disabled={true}
          type="text"
          value={status}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('unique_id')}
          disabled={true}
          type="text"
          value={uniqueId ? uniqueId : t('not_specified')}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('valid_from')}
          disabled={true}
          type="text"
          value={format(new Date(validFrom), 'dd.MM.yyyy')}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
      <div className="pt-6">
        <InputWithAlert
          label={t('valid_to')}
          disabled={true}
          type="text"
          value={format(new Date(validTo), 'dd.MM.yyyy')}
          inputClassName={'h-[40px] w-full  mt-2'}
        />
      </div>
    </div>
  )
}
